import React from 'react';
import { ExternalLink, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';

export const RewardCard = ({ reward, userCoins, onPurchase }) => {
  const canAfford = userCoins >= reward.cost;

  const handleRedeem = () => {
    // Se tem link de resgate, abre em nova aba
    if (reward.redemption_link) {
      window.open(reward.redemption_link, '_blank');
    }
    // Chama a função de compra para descontar as FerCoins
    onPurchase(reward.id);
  };

  return (
    <motion.div
      className={`bg-zinc-900/50 border backdrop-blur-md rounded-2xl overflow-hidden transition-colors duration-300 ${
        canAfford 
          ? 'border-yellow-500/30 hover:border-yellow-500/60' 
          : 'border-white/5 opacity-70'
      }`}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={canAfford ? { y: -4 } : {}}
      data-testid="reward-card"
    >
      {/* Imagem de thumbnail */}
      {reward.image_url ? (
        <div className="relative">
          <img 
            src={reward.image_url} 
            alt={reward.name}
            className="w-full h-40 object-cover"
          />
          {!canAfford && (
            <div className="absolute inset-0 bg-black/50 flex items-center justify-center">
              <Lock className="w-8 h-8 text-zinc-400" />
            </div>
          )}
        </div>
      ) : (
        <div className={`h-32 flex items-center justify-center ${canAfford ? 'bg-gradient-to-br from-yellow-500/10 to-yellow-700/10' : 'bg-zinc-800/50'}`}>
          <span className="text-6xl">{reward.icon}</span>
        </div>
      )}
      
      <div className="p-5">
        <h3 className="font-primary font-bold text-xl text-white mb-2">
          {reward.name}
        </h3>
        <p className="text-zinc-400 text-sm mb-4 line-clamp-2">{reward.description}</p>
        
        {/* Custo e botão */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 text-yellow-400 font-bold">
            <img src="/fercoin.png" alt="FerCoin" className="w-6 h-6" />
            {reward.cost}
          </div>
          
          {canAfford ? (
            <Button
              onClick={handleRedeem}
              className="bg-yellow-500 text-black font-black uppercase hover:bg-yellow-400 flex items-center gap-2"
              data-testid="purchase-button"
            >
              Resgatar
              {reward.redemption_link && <ExternalLink className="w-4 h-4" />}
            </Button>
          ) : (
            <div className="flex items-center gap-2 text-zinc-500 text-sm">
              <Lock className="w-4 h-4" />
              <span>Faltam {reward.cost - userCoins}</span>
            </div>
          )}
        </div>
        
        {/* Indicador de progresso para desbloquear */}
        {!canAfford && (
          <div className="mt-4">
            <div className="h-2 bg-zinc-800 rounded-full overflow-hidden">
              <motion.div
                className="h-full bg-gradient-to-r from-yellow-600 to-yellow-500"
                initial={{ width: 0 }}
                animate={{ width: `${Math.min((userCoins / reward.cost) * 100, 100)}%` }}
                transition={{ duration: 0.5 }}
              />
            </div>
            <p className="text-xs text-zinc-600 mt-1 text-center">
              {Math.round((userCoins / reward.cost) * 100)}% do necessário
            </p>
          </div>
        )}
      </div>
    </motion.div>
  );
};
